<template>
  <div class="row">
    <div
      class="col-12 col-sm-12 col-md-4 col-lg-4"
      v-for="record in Coaches"
      :key="record.id"
    >
      <div class="listing-item">
        <div class="listing-img">
          <router-link to="/pages/service-detail">
            <img
              :src="require(`@/assets/img/services/${record.Image}`)"
              class="img-fluid"
              alt="Service"
            />
          </router-link>
        </div>
        <div class="listing-content text-center">
          <h3 class="listing-title">
            <router-link to="/pages/service-detail">{{ record.Sports }}</router-link>
          </h3>
          <p>
            Our team of experienced and qualified coaches is dedicated to helping you
            achieve your goals.
          </p>
          <router-link to="/pages/service-detail" class="btn btn-secondary"
            >Read More</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Coaches from "@/assets/json/coaches.json";
export default {
  data() {
    return {
      Coaches: Coaches,
    };
  },
};
</script>
